<template>
  <div class="ui-schema-antd-tabs">
    <div class="ui-schema-antd-tabs-top-bar">
      <div class="ui-schema-antd-tabs-nav-container">
        <div 
          v-for="tab in tabList" 
          :key="tab.key" 
          class="ui-schema-antd-tabs-tab"
          :class="{ 'ui-schema-antd-tabs-tab-active': activeTab === tab.key }" 
          @click="switchTab(tab.key)"
        >
          {{ tab.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cTabs',
  props: {
    // 标签页列表
    tabList: {
      type: Array,
      required: true,
      default: () => []
    },
    // 当前激活的标签页
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      activeTab: this.value
    }
  },
  watch: {
    value(newVal) {
      this.activeTab = newVal
    }
  },
  methods: {
    switchTab(tabKey) {
      this.activeTab = tabKey
      this.$emit('input', tabKey)
      this.$emit('change', tabKey)
    }
  }
}
</script>

<style lang="less" scoped>
@base-color: var(--bi-jz-font-color);

.ui-schema-antd-tabs {
  height: 40px;
  width: 100%;

  .ui-schema-antd-tabs-top-bar {
    margin: 0;
    border-bottom: 1px solid var(--bi-jz-border-color);

    .ui-schema-antd-tabs-nav-container {
      height: 40px;
      position: relative;
      box-sizing: border-box;
      overflow: hidden;
      font-size: 14px;
      line-height: 1.5;
      white-space: nowrap;
      transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      display: flex;
      zoom: 1;

      .ui-schema-antd-tabs-tab {
        color: @base-color;
        cursor: pointer;
        flex: 1;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        height: 40px;
        border: none;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        
        &:hover {
          color: var(--bi-jz-font-color);
        }
      }

      .ui-schema-antd-tabs-tab-active {
        color: var(--bi-jz-font-color);
        font-weight: 700;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          background: #2e74ff;
          height: 2px;
          width: 30px;
          animation: tabActiveIndicator 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        }
      }
    }
  }
}

// 标签页激活指示器动画
@keyframes tabActiveIndicator {
  0% {
    width: 0;
    opacity: 0;
  }
  100% {
    width: 30px;
    opacity: 1;
  }
}
</style>
